<template>
    <v-snackbar
        v-if="snackbarVisible"
        id="dialog"
        v-model="snackbarVisible"
        :timeout="snackbarTimeout"
        :color="snackbarColor"
    >
      <p class="white--text ma-0 pa-0 d-flex flex-row justify-center align-center">
        <v-icon class="mr-2">{{ snackbarIcon }}</v-icon>
        {{ snackbarMessage }}
      </p>
    </v-snackbar>
  </template>
  
  <script>
  export default {
    name: "SimpleSnackbar",
  
    props: {
      snackbarColor: String,
      snackbarIcon: String,
      snackbarMessage: String,
    },
  
    data() {
      return {
        snackbarVisible: true,
        snackbarTimeout: 3000,
      }
    }
  }
  </script>
  
  <style scoped>
  #dialog {
    all: unset;
    position: relative;
  }
  </style>